import { render } from "./Dragable.vue?vue&type=template&id=46ca3ac8"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Dragable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46ca3ac8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46ca3ac8', __exports__)) {
    api.reload('46ca3ac8', __exports__)
  }
  
  module.hot.accept("./Dragable.vue?vue&type=template&id=46ca3ac8", () => {
    api.rerender('46ca3ac8', render)
  })

}


export default __exports__